import Page from "@/Pages/Page";
import React, {FormEvent, Fragment} from "react";
import imagePhone from "@images/media/phone.png";
import SectionHeader from "@/Organisms/SectionHeader/SectionHeader";

export default function Faq(props: any) {

  const handleToggle = (e: FormEvent<HTMLElement>) => {


    // close all others
    document.querySelectorAll('.question.open').forEach((question) => {
      question.classList.remove('open')
    })

    const target = e.target as HTMLDivElement;
    target.closest('.question')?.classList.toggle('open');
  }

  return <Page title={'Herdenkingspagina veelgestelde vragen'} harvestId={10879}>
    <SectionHeader
      beige
      image={imagePhone}
      title={'Veelgestelde vragen herdenkingspagina'}
      content={<p>In tijden van verlies en rouw kan een herdenkingspagina een waardevolle manier zijn om de herinnering
        aan
        een dierbare te behouden en te delen met anderen.
        Het kan ook een platform bieden om te rouwen en steun te vinden van vrienden en familie.
        Bekijk hieronder de meest gestelde vragen over herdenkingspagina’s.</p>}
    />

    <section className="faq">
      <div className="container grid gap-6 md:grid-cols-2">
        {Object.values(props.items).map((items, index) => <div key={index}>
            {Object.entries(items as object).map(([title, questions], index) => <Fragment key={index}>
                <h2>{title}</h2>
                {Object.entries(questions as object).map(([question, answer], questionIndex) =>
                  <div key={questionIndex} className="question" onClick={handleToggle}>
                    <h4>{question}</h4>
                    <div dangerouslySetInnerHTML={{__html: answer}}></div>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        )}
      </div>

    </section>
  </Page>
}

